export var INDEX_COUNT_RENDERER_TYPE = "INDEX";
var strategy = function (block, callback, contentState) {
    block.findEntityRanges(function (character) {
        var entityKey = character.getEntity();
        return (entityKey !== null &&
            contentState.getEntity(entityKey).getType() === INDEX_COUNT_RENDERER_TYPE);
    }, callback);
};
// eslint-disable-next-line import/no-default-export
export default strategy;
